import URL from '../helper';
import axiosCall from './interceptor';

// This file returns a function that accepts text as argument and return newly generated text.

// Function argument should be in text format.

export const generateTextFromData = async data => {
  const url = `${URL.BASE_URL}generate/text`;
  const resData = await axiosCall('post', url, {
    prompt: data,
  });
  return resData.data;
};

export const detectLanguage = async (payload) => {
  const response = await axiosCall("post", `${URL.BASE_URL}detectlanguage`, payload);
  return response.data;
}

export const detectLanguageDynamic = async (payload) => {
  const response = await axiosCall("put", `${URL.DESIGN_SYSTEM_URL}dynamic/detectLanguage`, payload);
  return response.data;
}